import { render, staticRenderFns } from "./TopicClusterLinkAnalysis.vue?vue&type=template&id=678432cf&scoped=true"
import script from "./TopicClusterLinkAnalysis.vue?vue&type=script&lang=js"
export * from "./TopicClusterLinkAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TopicClusterLinkAnalysis.vue?vue&type=style&index=0&id=678432cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678432cf",
  null
  
)

export default component.exports